import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {listTitleSizes} from '@adv-mt/mt-list-basic'
import ShieldCheckOutlineIcon from '@adv-mt/mt-svg-icons/lib/ShieldCheckOutline'

export const useGetInsuranceInfoContent = insuranceId => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {INSURANCE_IDS} = config.get('financing')
  const {SANTANDER_WITH_LIFE_INSURANCE, CASUALTY} = INSURANCE_IDS
  const isLifePlusInsurance = insuranceId === SANTANDER_WITH_LIFE_INSURANCE

  const insuranceLifePlusInfo = {
    title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.TITLE_LIFE_PLUS'),
    importantInfo: [
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_LIFE_PLUS_1'),
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_LIFE_PLUS_2')
    ],
    importantInfoTitle: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_TITLE'),
    itemsList: [
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_1_LIFE_PLUS'),
        value: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_VALUE_1_LIFE_PLUS'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_2_LIFE_PLUS'),
        value: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_VALUE_2_LIFE_PLUS'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_3_LIFE_PLUS'),
        value: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_VALUE_3_LIFE_PLUS'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_4_LIFE_PLUS'),
        value: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_VALUE_4_LIFE_PLUS'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_5_LIFE_PLUS'),
        value: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_VALUE_5_LIFE_PLUS'),
        titleSize: listTitleSizes.xs
      }
    ],
    listTitle: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LIST_TITLE_LIFE_PLUS'),
    description: [i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.DESCRIPTION_TEXT_LIFE_PLUS')]
  }

  const insuranceGapInfo = {
    title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.TITLE_GAP'),
    importantInfo: [
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_GAP_1'),
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_GAP_2'),
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_GAP_3')
    ],
    importantInfoTitle: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.IMPORTANT_INFO_TITLE'),
    itemsList: [
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_1_GAP'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_2_GAP'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_3_GAP'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_4_GAP'),
        titleSize: listTitleSizes.xs
      },
      {
        icon: () => <ShieldCheckOutlineIcon size="medium" />,
        title: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.ITEM_LIST_TITLE_5_GAP'),
        titleSize: listTitleSizes.xs
      }
    ],
    listTitle: i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.LIST_TITLE_GAP'),
    description: [
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.DESCRIPTION_TEXT_GAP_1'),
      i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.DESCRIPTION_TEXT_GAP_2')
    ]
  }

  const captionText = isLifePlusInsurance
    ? i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.CAPTION_TEXT_LIFE_PLUS')
    : i18n.t('PANEL_FINANCING.B2C.MODAL_INSURANCE_INFO.CAPTION_TEXT_GAP')

  const modalContent = {
    [SANTANDER_WITH_LIFE_INSURANCE]: [insuranceLifePlusInfo],
    [CASUALTY]: [insuranceLifePlusInfo, insuranceGapInfo]
  }

  return {captionText, modalInfo: modalContent[insuranceId] || []}
}
